import { InjectionKey } from 'vue'
import { ActionTree, createStore, GetterTree, MutationTree, Store, StoreOptions, useStore } from 'vuex'
import { EDeviceTypeName } from '../types'
import { Device, OSDRecordVisible, OSDZeroneVisible, DeviceHms, DeviceOsd, DeviceStatus, DockOsd, GatewayOsd, OSDVisible, MediaAiResult, MouseDownInfo, GbDevice, OSDGBVisible, Cameras_item, ZeroneDevice } from '../types/device'
import { getLayers } from '/@/api/layer'
import { LayerType } from '/@/types/mapLayer'
import { WaylineFile } from '/@/types/wayline'
import { DevicesCmdExecuteInfo } from '/@/types/device-cmd'
import { ListItem } from '/@/types/dashboard-xa'

// 定义事件类型接口
interface EventCategory {
  category_code: string
  category_name: string
  industry_type: string
  description: string
  checked: boolean
}

const initStateFunc = () => ({
  Layers: [],
  layerBaseInfo: {} as {
    [key:string]:string
  },
  drawVisible: false,
  livestreamOthersVisible: false,
  livestreamAgoraVisible: false,
  cameraScreenSplitEnable: false,
  setModelEnablePolyon: false,
  setModelEnablePolyonOK: false,
  setDrawTargetPoint: false,
  setDrawWorkspaceCenterPoint: false,
  setDroneHighSpeed: false, // 指令飞行高速模式
  layerVisibility: {
    data2d: true, // 二维图层默认显示
    data3d: true, // 三维图层默认显示
    airLine: false // 航线显示 默认关闭
  } as { data2d: boolean; data3d: boolean, airLine: boolean },
  // 当天航线数据
  todayFlightPlans: [] as any[],
  setModelEnablePolyonData: [

  ] as any,
  setDrawWorkspaceCenterPointData: [

  ] as any,
  setWaylinePolygonAdd: {},
  setWaylinePolygonDel: {},
  // coverList: [
  // ] as any,
  coverMap: {} as {
    [key: string]: any[]
  },
  coverList: [

  ] as any,
  waylineList: [

  ] as any,
  coverFolderMap: [

  ] as any,
  waylinePointList: [

  ] as any,
  waylinePointCircleList: [

  ] as any,
  waylinePointListEditer: [

  ] as any,
  folderTreeSelectedData: [

  ] as any,
  folderTreeRemovedData: [],
  wsEvent: {
    mapElementCreat: {},
    mapElementUpdate: {},
    mapElementDelete: {}
  },
  deviceStatusEvent: {
    deviceOnline: {} as DeviceStatus,
    deviceOffline: {}
  },
  markerInfo: {
    coverMap: {} as {
      [sn: string]: any
    },
    pathMap: {} as {
      [sn: string]: any[]
    }
  },
  markerMapInfo: {
    coverMap: {} as {
      [sn: string]: any
    },
    mapData: [] as MediaAiResult[],
    mapNoneData: [] as MediaAiResult[],
  },
  mapMouseDownInfo: {
    action: -1,
    longitude: 0,
    latitude: 0,
    altitude: 0,
  } as MouseDownInfo,
  deviceState: {
    // remote controller, dock
    gatewayInfo: {} as {
      [sn: string]: GatewayOsd
    },
    // drone
    deviceInfo: {} as {
      [sn: string]: DeviceOsd
    },
    dockInfo: {} as {
      [sn: string]: DockOsd
    },
    // gb28181
    gbInfo: {} as {
      [sn: string]: GbDevice
    },
    zoneInfo: {} as {
      [sn: string]: ZeroneDevice
    },
    currentSn: '',
    currentType: -1
  },
  deviceInspectInfo: {
    create_time: 0,
    job_id: '',
    lon: 0,
    lat: 0,
    path: '',
    result: '',
    sn: '',
    type: 0,
    wayline_id: ''
  },
  psdkFloatingWindowText: {
    psdk_index: 0,
    value: '',
  },
  osdVisible: { // osd 显示设备相关信息
    sn: '',
    callsign: '',
    model: '',
    visible: false,
    gateway_sn: '',
    is_dock: false,
    is_setCenter: false,
    payloads: null,
    cameras_list: [] as Cameras_item[]
  } as OSDVisible,
  // active位置状态管理
  activePosition: {
    sn: '', // 当前active媒体的file_id
    iconUrl: '',
    coordinates: {
      longitude: 0,
      latitude: 0,
      altitude: 0
    }
  },
  osdGBVisible: { // osd 显示设备相关信息
    deviceId: '',
    name: '',
    model: '',
    visible: false,
    channels: null
  } as OSDGBVisible,
  osdZONEVisible: { // osd 显示设备相关信息
    deviceId: '',
    name: '',
    model: '',
    visible: false,
    channels: null
  } as OSDZeroneVisible,
  waylineInfo: {

  } as WaylineFile,
  osdRecordVisible: {

  } as OSDRecordVisible,
  panelResize: {

  },
  dockInfo: {

  } as Device,
  hmsInfo: {} as {
    [sn: string]: DeviceHms[]
  },
  // 机场指令执行状态信息
  devicesCmdExecuteInfo: {
  } as DevicesCmdExecuteInfo,
  mqttState: null as any, // mqtt 实例
  clientId: '', // mqtt 连接 唯一客户端id
  currentTaskDockSn: '', // 计划库当前选中的机场dock_sn
  currentMediaDockSn: '', // 计划库当前选中的机场dock_sn
  currentMediaAiDockSn: '', // 计划库当前选中的机场dock_sn
  currentInspectDockSn: '', // 计划库当前选中的机场dock_sn
  currentMediaLiveSn: '', // 直播当前选中的device_sn
  isLeftFold: false, // 大屏左侧面板是否折叠
  isRightFold: false, // 大屏右侧面板是否折叠
  isLargeScreen: false, // 是否是大屏模式
  isEventTypeModalVisible: false, // 事件类型选择弹窗是否显示
  selectedCustomEventTypes: [] as EventCategory[], // 选中的自定义事件类型
  isShowDockInfoDetailPanel: false, // 机场信息详情面板
  dockInfoDetailPanelName: '', // 机场信息详情面板名称
  dockInfoDetailPanelSn: '', // 机场信息详情面板sn
  isTimeSpaceMappingModalVisible: false, // 视界搜图弹窗是否显示
  isCoordinatePicking: false, // 拾取按钮状态是否拾取中
  timeSpaceMappingCoordinate: null as {
    longitude: number,
    latitude: number,
    altitude: number,
  } | null, // 视界搜图拾取坐标
  timeSpaceMappingData: [] as any[], // 视界搜图数据
  currentTimeSpaceMappingFileId: '', // 当前选中的视界搜图图片ID
  isTimeSpaceMappingClusterEnabled: true, // 视界搜图聚合开关，默认开启
  // 航线回放媒体点数据
  flightRecordMediaData: [] as any[],
  // 航线回放详情弹窗显示状态
  flightRecordDetailVisible: false,
  // 航线回放详情弹窗位置
  flightRecordDetailPosition: 'bottom-left' as 'center' | 'bottom-left',
  // 当前选中的航线回放job_id
  currentFlightRecordJobId: '',
  // 当前选中的媒体文件ID
  currentFlightRecordFileId: '',
  // 当前高亮的媒体点ID
  activeFlightRecordMediaId: '',
  isPanoramaIconVisible: false, // 全景图是否显示
  panoramaData: [] as any[], // 全景图数据
  isWarningEventVisible: false, // 预警事件是否显示
  warningEventData: [] as any[], // 预警事件数据
  selectedWarningEvent: null as ListItem | null, // 当前选中的预警事件
  isLiveListModalVisible: false, // 直播列表弹窗是否显示
  isQdq: false, // 是否启动区跳转页
  warningEventPageNumber: 100, // 预警事件分页数量, 需要和左侧AI预警事件统计数量一致
  flyToProjectCenter: false, // 是否飞到项目中心点
  gatewaySn: '', // 机场序列号
  deviceSn: '', // 无人机序列号
})

export type RootStateType = ReturnType<typeof initStateFunc>

const getters: GetterTree<RootStateType, RootStateType> = {
}
const mutations: MutationTree<RootStateType> = {
  SET_LAYER_INFO (state, info) {
    state.Layers = info
  },
  SET_IS_LEFT_FOLD (state, value) {
    state.isLeftFold = value
  },
  TOGGLE_IS_LEFT_FOLD (state) {
    state.isLeftFold = !state.isLeftFold
  },
  SET_IS_RIGHT_FOLD (state, value) {
    state.isRightFold = value
  },
  TOGGLE_IS_RIGHT_FOLD (state) {
    state.isRightFold = !state.isRightFold
  },
  SET_IS_LARGE_SCREEN (state, value) {
    state.isLargeScreen = value
  },
  SET_DEVICE_INFO (state, info) {
    state.deviceState.deviceInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Aircraft
  },
  SET_INSPECT_INFO (state, info) {
    state.deviceInspectInfo = info
  },
  SET_PSDK_FLOATING_WINDOW_TEXT (state, info) {
    state.psdkFloatingWindowText = info
  },
  SET_GB_INFO (state, info) {
    state.deviceState.gbInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Gb28281
  },
  SET_ZONE_INFO (state, info) {
    state.deviceState.zoneInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Zerone
  },
  SET_GATEWAY_INFO (state, info) {
    state.deviceState.gatewayInfo[info.sn] = info.host
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Gateway
  },
  SET_DOCK_INFO (state, info) {
    if (Object.keys(info.host).length === 0) {
      return
    }
    if (!state.deviceState.dockInfo[info.sn]) {
      state.deviceState.dockInfo[info.sn] = { } as DockOsd
    }
    state.deviceState.currentSn = info.sn
    state.deviceState.currentType = EDeviceTypeName.Dock
    const dock = state.deviceState.dockInfo[info.sn]
    if (info.host.mode_code !== undefined) {
      dock.basic_osd = info.host
      return
    }
    // if (info.host.sdr) {
    if (info.host.wireless_link) {
      dock.link_osd = info.host
      return
    }
    if (info.host.job_number !== undefined) {
      dock.work_osd = info.host
    }
  },
  SET_DRAW_VISIBLE_INFO (state, bool) {
    state.drawVisible = bool
  },
  SET_LIVESTREAM_OTHERS_VISIBLE (state, bool) {
    state.livestreamOthersVisible = bool
  },
  SET_LIVESTREAM_AGORA_VISIBLE (state, bool) {
    state.livestreamAgoraVisible = bool
  },
  SET_MAP_ELEMENT_CREATE (state, info) {
    state.wsEvent.mapElementCreat = info
  },
  SET_MAP_ELEMENT_UPDATE (state, info) {
    state.wsEvent.mapElementUpdate = info
  },
  SET_MAP_ELEMENT_DELETE (state, info) {
    state.wsEvent.mapElementDelete = info
  },
  SET_DEVICE_ONLINE (state, info) {
    state.deviceStatusEvent.deviceOnline = info
  },
  SET_DEVICE_OFFLINE (state, info) {
    state.deviceStatusEvent.deviceOffline = info
    delete state.deviceState.gatewayInfo[info.sn]
    delete state.deviceState.deviceInfo[info.sn]
    delete state.deviceState.dockInfo[info.sn]
    delete state.hmsInfo[info.sn]
    // delete state.markerInfo.coverMap[info.sn]
    // delete state.markerInfo.pathMap[info.sn]
  },
  SET_OSD_VISIBLE_INFO (state, info) {
    state.osdVisible = info
  },
  SET_GB_OSD_VISIBLE_INFO (state, info) {
    state.osdGBVisible = info
  },
  SET_ZONE_OSD_VISIBLE_INFO (state, info) {
    state.osdZONEVisible = info
  },
  SET_SELECT_WAYLINE_INFO (state, info) {
    state.waylineInfo = info
  },
  SET_SELECT_DOCK_INFO (state, info) {
    state.dockInfo = info
  },
  SET_DEVICE_HMS_INFO (state, info) {
    const hmsList: Array<DeviceHms> = state.hmsInfo[info.sn]
    state.hmsInfo[info.sn] = info.host.concat(hmsList ?? [])
  },
  SET_DEVICES_CMD_EXECUTE_INFO (state, info) { // 保存设备指令ws消息推送
    if (!info.sn) {
      return
    }
    if (state.devicesCmdExecuteInfo[info.sn]) {
      const index = state.devicesCmdExecuteInfo[info.sn].findIndex(cmdExecuteInfo => cmdExecuteInfo.biz_code === info.biz_code)
      if (index >= 0) {
        // 丢弃前面的消息
        if (state.devicesCmdExecuteInfo[info.sn][index].timestamp > info.timestamp) {
          return
        }
        state.devicesCmdExecuteInfo[info.sn][index] = info
      } else {
        state.devicesCmdExecuteInfo[info.sn].push(info)
      }
    } else {
      state.devicesCmdExecuteInfo[info.sn] = [info]
    }
  },
  SET_MQTT_STATE (state, mqttState) {
    state.mqttState = mqttState
  },
  SET_CLIENT_ID (state, clientId) {
    state.clientId = clientId
  },
  SET_TASK_DOCK_SN (state, deviceSn) {
    state.currentTaskDockSn = deviceSn
  },
  SET_MEDIA_DOCK_SN (state, deviceSn) {
    state.currentMediaDockSn = deviceSn
  },
  SET_MEDIA_LIVE_SN (state, deviceSn) {
    state.currentMediaLiveSn = deviceSn
  },
  SET_MEDIA_AI_DOCK_SN (state, deviceSn) {
    state.currentMediaAiDockSn = deviceSn
  },
  SET_INSPECT_DOCK_SN (state, deviceSn) {
    state.currentInspectDockSn = deviceSn
  },
  SET_MARKER_MAP_INFO (state, data) {
    state.markerMapInfo.mapData = data
  },
  SET_MARKER_MAP_INFO_NONE (state, data) {
    state.markerMapInfo.mapNoneData = data
  },
  SET_MAP_MOUSE_DOWN_INFO (state, data) {
    // console.log('mapMouseDownInfo===11111===', data)
    state.mapMouseDownInfo.longitude = data.longitude
    state.mapMouseDownInfo.latitude = data.latitude
    state.mapMouseDownInfo.altitude = data.altitude
    state.mapMouseDownInfo.action = data.action
  },
  SET_WAYLINEPOINT (state, data) {
    state.waylinePointList = data
  },
  SET_WAYLINEPOINT_CIRCLE (state, data) {
    state.waylinePointCircleList = data
  },
  SET_WAYLINEPOINTEDITER (state, data) {
    state.waylinePointListEditer = data
  },
  SET_PANEL_RESIZE (state, data) {
    state.panelResize = data
  },
  SET_RECORDINFO (state, data) {
    state.osdRecordVisible = data
  },
  SET_CAMERA_SCREEN_SPLIT_ENABLE (state, bool) {
    state.cameraScreenSplitEnable = bool
  },
  SET_FOLDER_TREE_SELECTED_DATA (state, data) {
    state.folderTreeSelectedData = data
  },
  SET_FOLDER_TREE_REMOVE_DATA (state, data) {
    state.folderTreeRemovedData = data
  },
  SET_MODEL_ENABLE_POLYON (state, bool) {
    state.setModelEnablePolyon = bool
  },
  SET_MODEL_ENABLE_POLYON_OK (state, bool) {
    state.setModelEnablePolyonOK = bool
  },
  SET_DRAW_TARGET_POINT (state, bool) {
    state.setDrawTargetPoint = bool
  },
  SET_DRONE_HIGH_SPEED (state, bool) {
    state.setDroneHighSpeed = bool
  },
  SET_MODEL_ENABLE_POLYON_DATA (state, data) {
    state.setModelEnablePolyonData = data
  },
  SET_DRAW_WORKSPACE_CENTER_POINT (state, bool) {
    state.setDrawWorkspaceCenterPoint = bool
  },
  SET_DRAW_WORKSPACE_CENTER_POINT_DATA (state, data) {
    state.setDrawWorkspaceCenterPointData = data
  },
  SET_LAYER_VISIBILITY (state, { layerType, visible }: { layerType: 'data2d' | 'data3d' | 'airLine', visible: boolean }) {
    state.layerVisibility[layerType] = visible
  },
  TOGGLE_LAYER_VISIBILITY (state, layerType: 'data2d' | 'data3d' | 'airLine') {
    state.layerVisibility[layerType] = !state.layerVisibility[layerType]
  },
  // 设置当天航线数据
  SET_TODAY_FLIGHT_PLANS (state, plans: any[]) {
    state.todayFlightPlans = plans
  },
  // 清空当天航线数据
  CLEAR_TODAY_FLIGHT_PLANS (state) {
    state.todayFlightPlans = []
  },
  SET_WAYLINE_POLYGON_ADD (state, data) {
    state.setWaylinePolygonAdd = data
  },
  SET_WAYLINE_POLYGON_DEL (state, data) {
    state.setWaylinePolygonDel = data
  },
  SET_IS_EVENT_TYPE_MODAL_VISIBLE (state, value) {
    state.isEventTypeModalVisible = value
  },
  TOGGLE_IS_EVENT_TYPE_MODAL_VISIBLE (state) {
    state.isEventTypeModalVisible = !state.isEventTypeModalVisible
  },
  SET_SELECTED_CUSTOM_EVENT_TYPES (state, types) {
    state.selectedCustomEventTypes = types
  },

  SET_IS_SHOW_DOCK_INFO_DETAIL_PANEL (state, value) {
    state.isShowDockInfoDetailPanel = value
  },
  SET_DOCK_INFO_DETAIL_PANEL_NAME (state, value) {
    state.dockInfoDetailPanelName = value
  },
  SET_DOCK_INFO_DETAIL_PANEL_SN (state, value) {
    state.dockInfoDetailPanelSn = value
  },
  // 视界搜图弹窗
  SET_IS_TIME_SPACE_MAPPING_MODAL_VISIBLE (state, value) {
    state.isTimeSpaceMappingModalVisible = value
  },
  TOGGLE_IS_TIME_SPACE_MAPPING_MODAL_VISIBLE (state) {
    state.isTimeSpaceMappingModalVisible = !state.isTimeSpaceMappingModalVisible
  },
  // 拾取按钮状态
  SET_COORDINATE_PICKER_STATUS (state, value) {
    state.isCoordinatePicking = value
  },
  TOGGLE_COORDINATE_PICKER_STATUS (state) {
    state.isCoordinatePicking = !state.isCoordinatePicking
  },
  // 视界搜图拾取坐标
  SET_TIME_SPACE_MAPPING_COORDINATE (state, data) {
    state.timeSpaceMappingCoordinate = data
  },
  // 视界搜图数据
  SET_TIME_SPACE_MAPPING_DATA (state, data) {
    state.timeSpaceMappingData = data
  },
  // 设置当前选中的视界搜图图片ID
  SET_CURRENT_TIME_SPACE_MAPPING_FILE_ID (state, fileId) {
    state.currentTimeSpaceMappingFileId = fileId
  },
  // 切换视界搜图聚合开关
  TOGGLE_TIME_SPACE_MAPPING_CLUSTER (state) {
    state.isTimeSpaceMappingClusterEnabled = !state.isTimeSpaceMappingClusterEnabled
  },
  // 设置active位置
  SET_ACTIVE_POSITION (state, data) {
    state.activePosition = {
      ...state.activePosition,
      ...data
    }
  },
  // 清除active位置
  CLEAR_ACTIVE_POSITION (state) {
    state.activePosition = {
      sn: '',
      iconUrl: '',
      coordinates: {
        longitude: 0,
        latitude: 0,
        altitude: 0
      }
    }
  },
  // 设置全景图
  SET_IS_PANORAMA_ICON_VISIBLE (state, value) {
    state.isPanoramaIconVisible = value
  },
  TOGGLE_IS_PANORAMA_ICON_VISIBLE (state) {
    state.isPanoramaIconVisible = !state.isPanoramaIconVisible
  },
  // 设置全景图数据
  SET_PANORAMA_DATA (state, data) {
    state.panoramaData = data
  },

  // 航线回放媒体点数据
  SET_FLIGHT_RECORD_MEDIA_DATA (state, data) {
    state.flightRecordMediaData = data
  },

  // 航线回放详情弹窗显示状态
  SET_FLIGHT_RECORD_DETAIL_VISIBLE (state, value) {
    state.flightRecordDetailVisible = value
  },
  // 航线回放详情弹窗位置
  SET_FLIGHT_RECORD_DETAIL_POSITION (state, value) {
    state.flightRecordDetailPosition = value
  },
  // 当前选中的航线回放job_id
  SET_CURRENT_FLIGHT_RECORD_JOB_ID (state, value) {
    state.currentFlightRecordJobId = value
  },
  // 当前选中的媒体文件ID
  SET_CURRENT_FLIGHT_RECORD_FILE_ID (state, value) {
    state.currentFlightRecordFileId = value
  },
  // 当前高亮的媒体点ID
  SET_ACTIVE_FLIGHT_RECORD_MEDIA_ID (state, value) {
    state.activeFlightRecordMediaId = value
  },

  // 设置预警事件
  TOGGLE_IS_WARNING_EVENT_VISIBLE (state) {
    state.isWarningEventVisible = !state.isWarningEventVisible
  },
  // 设置预警事件数据
  SET_WARNING_EVENT_DATA (state, data) {
    state.warningEventData = data
  },
  // 设置当前选中的预警事件
  SET_SELECTED_WARNING_EVENT (state, data) {
    state.selectedWarningEvent = data
  },
  // 设置直播列表弹窗是否显示
  SET_LIVE_LIST_MODAL_VISIBLE (state, value) {
    state.isLiveListModalVisible = value
  },
  // 切换直播列表弹窗是否显示
  TOGGLE_LIVE_LIST_MODAL_VISIBLE (state) {
    state.isLiveListModalVisible = !state.isLiveListModalVisible
  },
  // 启动区
  SET_IS_QDQ (state, value) {
    state.isQdq = value
  },
  SET_WARNING_EVENT_PAGE_NUMBER (state, value) {
    state.warningEventPageNumber = value
  },
  // 设置是否飞到项目中心点
  SET_FLY_TO_PROJECT_CENTER (state, value) {
    state.flyToProjectCenter = value
  },
  SET_GATEWAY_SN (state, value) {
    state.gatewaySn = value
  },
  SET_DEVICE_SN (state, value) {
    state.deviceSn = value
  }
}

const actions: ActionTree<RootStateType, RootStateType> = {
  async getAllElement ({ commit }) {
    const result = await getLayers({
      groupId: '',
      isDistributed: true
    })
    commit('SET_LAYER_INFO', result.data?.list)
    console.log(result)
  },
  updateElement ({ state }, content: {type: 'is_check' | 'is_select', id: string, bool:boolean}) {
    const key = content.id.replaceAll('resource__', '')
    const type = content.type
    const layers = state.Layers
    const layer = layers.find(item => item.id === key)
    if (layer) {
      layer[type] = content.bool
    }
  },
  setLayerInfo ({ state }, layers) {
    // const layers = state.Layers
    const obj:{
      [key:string]:string
    } = {}
    layers.forEach(layer => {
      if (layer.type === LayerType.Default) {
        obj.default = layer.id
      } else {
        if (layer.type === LayerType.Share) {
          obj.share = layer.id
        }
      }
    })
    state.layerBaseInfo = obj
    // console.log('state.layerBaseInfo', state.layerBaseInfo)
  },
  getLayerInfo ({ state }, id:string) {
    return state.layerBaseInfo[id]
  }
}

const storeOptions: StoreOptions<RootStateType> = {
  state: initStateFunc,
  getters,
  mutations,
  actions
}

const rootStore = createStore(storeOptions)

export default rootStore

export const storeKey: InjectionKey<Store<RootStateType>> = Symbol('')

type AllStateStoreTypes = RootStateType & {
  // moduleName: moduleType
}

export function useMyStore<T = AllStateStoreTypes> () {
  return useStore<T>(storeKey)
}
